import src from "IMAGE";
export default { src, width: 946, height: 503, blurWidth: 0, blurHeight: 0};
